import { render, staticRenderFns } from "./loadData.vue?vue&type=template&id=5b0cb54e"
import script from "./loadData.vue?vue&type=script&lang=js"
export * from "./loadData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports